import Component from '@component';

export default class UserLoadAccountPage extends Component {
	onInit(el, args) {
		const loginEvent = {};
		loginEvent.event = 'login';
		loginEvent.method = 'email';

		if (window.sessionStorage.getItem('userLogin') === 'yes') {
			window.sessionStorage.removeItem('userLogin');
			dataLayer.push(loginEvent);
		}
	}
}
